<template>
  <div>

    <div class="center-content w-full">
      <Card class="w-full">
        <template v-slot:content>
          <h1 class="page-title">Upload & Import File TIMOE/TIMG</h1>
          <div class="flex align-items-center flex-column">
            <div class="dropdown-wrapper mb-2">
              <select v-model="selectedTimoePath" id="timoeDestination" class="custom-dropdown">
                <option disabled value="">Seleziona un percorso</option>
                <option v-for="(path, key) in timoePaths" :key="key" :value="path">
                  {{ key }} 
                </option>
              </select>
            </div>
             <div v-show="timoeValidationErrors.path && timoeSubmitted" class="p-error">
               Selezionare un percorso di destinazione.
             </div>
            <div class="button-wrapper mb-2">
              <span class="label">{{
                timoeFilesToUpload.length == 0
                  ? "Seleziona File CSV/XLSX"
                  : timoeFilesToUpload.length + " file(s) selezionati"
              }}</span>
              <input id="uploadTimoe" type="file" ref="timoeFile" @change="handleTimoeFileUpload($event)"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" multiple />
            </div>
             <div v-show="timoeValidationErrors.files && timoeSubmitted" class="p-error">
              Selezionare almeno un file.
            </div>
            <div v-show="timoeValidationErrors.type && timoeSubmitted" class="p-error">
              Formato non consentito (solo .csv o .xlsx)
            </div>
            <div class="text-center mt-3">
              <small>Formati consentiti: .csv, .xlsx (I file devono essere importati partendo dalla colonna CP_GESTORE)</small>
            </div>
            <div class="button-group">
               <Button @click="uploadTimoeFiles" label="1. Carica File " class="upload-button" :disabled="loading" />
               
            </div>
            <div>
              <Button @click="importEEDatabase" label="2. Importa File EE in Ask" class="import-db-button ml-4" :disabled="loading" />
               <Button @click="importGasDatabase" label="3. Importa File GAS in Ask" class="import-gas-button ml-4" :disabled="loading" />
            </div>
             <div v-if="loading" class="mt-3">
                <ProgressSpinner style="width:50px;height:50px" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"/>
             </div>
          </div>
        </template>
      </Card>
    </div>
   
    <div class="center-content w-full mt-3">
      <Card class="w-full">
        <template v-slot:content>
          <h1 class="page-title">File Importati TIMOE/TIVG</h1>
          <div class="flex align-items-center">
            <Button @click="fetchImportedFiles" icon="pi pi-refresh" class="p-button-sm mb-2" />
          </div>
          
          <div class="tabs">
            <div class="tab-header">
              <div 
                @click="activeTab = 'ee'" 
                :class="['tab-button', { active: activeTab === 'ee' }]">
                EE ({{ importedFiles.ee?.count || 0 }})
              </div>
              <div 
                @click="activeTab = 'gas'" 
                :class="['tab-button', { active: activeTab === 'gas' }]">
                GAS ({{ importedFiles.gas?.count || 0 }})
              </div>
            </div>
            
            <div class="tab-content">
              <div v-if="loadingImportedFiles" class="text-center p-4">
                <ProgressSpinner style="width:50px;height:50px" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"/>
              </div>
              
              <div v-else-if="activeTab === 'ee'">
                <DataTable :value="importedFiles.ee?.files || []" 
                           :paginator="importedFiles.ee?.files?.length > 10" 
                           :rows="10"
                           stripedRows
                           class="p-datatable-sm"
                           v-if="importedFiles.ee?.files?.length">
                  <Column field="value" header="Nome File" sortable>
                    <template #body="slotProps">
                      {{ slotProps.data }}
                    </template>
                  </Column>
                </DataTable>
                <div v-else class="text-center p-3">Nessun file EE importato.</div>
              </div>
              
              <div v-else-if="activeTab === 'gas'">
                <DataTable :value="importedFiles.gas?.files || []" 
                           :paginator="importedFiles.gas?.files?.length > 10" 
                           :rows="10"
                           stripedRows
                           class="p-datatable-sm"
                           v-if="importedFiles.gas?.files?.length">
                  <Column field="value" header="Nome File" sortable>
                    <template #body="slotProps">
                      {{ slotProps.data }}
                    </template>
                  </Column>
                </DataTable>
                <div v-else class="text-center p-3">Nessun file GAS importato.</div>
              </div>
            </div>
          </div>
        </template>
      </Card>
    </div>

    <div class="center-content w-full mt-3">
      <Card class="w-full">
        <template v-slot:content>
          <h1 class="page-title">Ricerca Dati TIMOE/TIMG per Codice</h1>
          <div class="search-wrapper">
            <InputText 
                type="text" 
                v-model="searchCode" 
                placeholder="Inserisci Il Code" 
                class="search-input"
                @keyup.enter="searchTimoeData" />
            <Button 
                label="Cerca" 
                @click="searchTimoeData" 
                :disabled="loadingSearch || !searchCode" 
                class="search-button" />
          </div>
           <div v-if="loadingSearch" class="text-center mt-3">
              <ProgressSpinner style="width:50px;height:50px" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"/>
           </div>

           <div v-if="searchResults.length > 0 && !loadingSearch" class="mt-3">
              <DataTable :value="searchResults" 
                          stripedRows
                          responsiveLayout="scroll"
                          class="p-datatable-sm">
                 <Column v-for="col in searchResultColumns" 
                          :key="col.field" 
                          :field="col.field" 
                          :header="col.header" 
                          sortable>
                      <template #body="slotProps">
                         {{ slotProps.data[col.field] }}
                      </template>
                 </Column>
              </DataTable>
           </div>
           <div v-else-if="searchSubmitted && !loadingSearch && searchResults.length === 0" class="text-center p-3 mt-3">
              Nessun risultato trovato per il codice inserito.
           </div>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import { ref, computed, getCurrentInstance, onMounted } from "vue";
import Service from "@/services/ask-caricamento-file/caricamento-file";
import { useToast } from "primevue/usetoast";
import Button from "primevue/button";
import Card from "primevue/card";
import ProgressSpinner from 'primevue/progressspinner'; 
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';

export default {
  components: {
    Button,
    Card,
    ProgressSpinner,
    DataTable,
    Column,
    InputText
  },
  setup() {
    const email = ref("");
    const logData = ref([]);
    const validationErrors = ref({});
    const submitted = ref(false);
    const toast = useToast();
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    const service = new Service(self.$eventBus);

    const timoePaths = ref({});
    const selectedTimoePath = ref('');
    const timoeFilesToUpload = ref([]);
    const timoeValidationErrors = ref({});
    const timoeSubmitted = ref(false);
    const loading = ref(false);

    const importedFiles = ref({
      ee: { count: 0, files: [] },
      gas: { count: 0, files: [] }
    });
    const activeTab = ref('ee');
    const loadingImportedFiles = ref(false);

    const searchCode = ref('');
    const searchResults = ref([]);
    const searchResultType = ref(null); 
    const loadingSearch = ref(false);
    const searchSubmitted = ref(false);

    const fetchTimoePaths = async () => {
      loading.value = true; 
      try {
        timoePaths.value = await service.getTimoePathsFtp();
      } catch (error) {
        toast.add({
          severity: "error",
          summary: "Errore Percorsi",
          detail: "Errore nel recupero dei percorsi TIMOE/TIVG.",
          life: 5000,
        });
      } finally {
          loading.value = false;
      }
    };

    const handleTimoeFileUpload = (evt) => {
      timoeSubmitted.value = false;
      timoeFilesToUpload.value = self.refs.timoeFile.files;
      timoeValidationErrors.value = {};
    };

    const validateTimoeForm = () => {
      timoeValidationErrors.value = {};
      if (timoeFilesToUpload.value.length === 0) {
          timoeValidationErrors.value['files'] = true;
      } else {
          const allowedExtensions = ['csv', 'xlsx'];
          let valid = [...timoeFilesToUpload.value].every(file => {
              const extension = file.name.split('.').pop()?.toLowerCase();
              return extension && allowedExtensions.includes(extension);
          });
          if (!valid) timoeValidationErrors.value['type'] = true;
      }
      if (!selectedTimoePath.value) {
          timoeValidationErrors.value['path'] = true;
      }
      return Object.keys(timoeValidationErrors.value).length === 0;
    };

    const uploadTimoeFiles = async () => {
      timoeSubmitted.value = true;
      if (validateTimoeForm()) {
        loading.value = true;
        try {

          const response = await service.importTimoeFilesFtp(timoeFilesToUpload.value);

          toast.add({
            severity: 'success',
            summary: 'Caricamento Completato',
            detail: 'L\'operazione di caricamento è terminata.',
            life: 5000
          });

          if (response.results && response.results.length > 0) {
            response.results.forEach(result => {
              toast.add({
                severity: result.status === 'success' ? 'info' : 'warn',
                summary: `File: ${result.file}`,
                detail: result.message + (result.path ? ` (Path: ${result.path})` : ''), 
                life: 7000
              });
            });
          }

          timoeFilesToUpload.value = [];
          selectedTimoePath.value = ''; 
          if (self.refs.timoeFile) { 
             self.refs.timoeFile.value = null;
          }
          timoeSubmitted.value = false;

        } catch (error) {
          console.error("Errore durante il caricamento dei file TIMOE:", error);
          const detailMessage = error.response?.data?.message || error.message || "Si è verificato un errore durante il caricamento.";
          if (error.response?.status === 400 && detailMessage.includes('Nessun file fornito')) {
             toast.add({
                 severity: "warn",
                 summary: "Attenzione",
                 detail: "Nessun file valido trovato per il caricamento.",
                 life: 5000,
             });
          } else {
              toast.add({
                  severity: "error",
                  summary: "Errore Caricamento",
                  detail: detailMessage,
                  life: 5000,
              });
          }
        } finally {
          loading.value = false;
        }
      }
    };

    const formatTimestamp = (timestamp) => {
      const date = new Date(timestamp * 1000);
      return date.toLocaleString();
    };

    const importEEDatabase = async () => {
      loading.value = true;
      try {
        const response = await service.importTimoeEEFilesDatabase();

        toast.add({
          severity: 'success',
          summary: 'Importazione Database Completata',
          detail: 'Operazione di importazione dei file EE nel database terminata.',
          life: 5000
        });

        if (response.results && response.results.length > 0) {
           let fileErrors = 0;
           response.results.forEach(result => {
             const severity = result.status === 'success' ? 'info' : 'warn';
             if (result.status !== 'success') fileErrors++;
             toast.add({
               severity: severity,
               summary: `File: ${result.file}`,
               detail: `${result.message}${result.status === 'success' ? ' (' + result.records_imported + ' record)' : ''}`,
               life: 7000
             });
           });
           if(fileErrors > 0) {
                toast.add({
                    severity: 'warn',
                    summary: 'Problemi Riscontrati',
                    detail: `Ci sono stati errori durante l'importazione di ${fileErrors} file. Controllare i dettagli.`,
                    life: 6000
                });
           }
        } else if (response.status === 'success' && (!response.results || response.results.length === 0)) {
             toast.add({
               severity: 'info',
               summary: 'Nessun File da Importare',
               detail: 'Non sono stati trovati nuovi file EE da importare nella cartella di origine.',
               life: 6000
             });
        }

      } catch (error) {
        console.error("Errore durante l'importazione EE nel database:", error);
        toast.add({
          severity: "error",
          summary: "Errore Importazione DB",
          detail: error.response?.data?.message || error.message || "Si è verificato un errore durante l'importazione nel database.",
          life: 6000,
        });
      } finally {
        loading.value = false;
      }
    };

    const importGasDatabase = async () => {
      loading.value = true;
      try {
        const response = await service.importTimgGasFilesDatabase();

        toast.add({
          severity: 'success',
          summary: 'Importazione Database GAS Completata',
          detail: 'Operazione di importazione dei file GAS nel database terminata.',
          life: 5000
        });

        if (response.results && response.results.length > 0) {
          let fileErrors = 0;
          response.results.forEach(result => {
            const severity = result.status === 'success' ? 'info' : 'warn';
            if (result.status !== 'success') fileErrors++;
            toast.add({
              severity: severity,
              summary: `File: ${result.file}`,
              detail: `${result.message}${result.status === 'success' ? ' (' + result.records_imported + ' record)' : ''}`,
              life: 7000
            });
          });
          if(fileErrors > 0) {
            toast.add({
              severity: 'warn',
              summary: 'Problemi Riscontrati',
              detail: `Ci sono stati errori durante l'importazione di ${fileErrors} file. Controllare i dettagli.`,
              life: 6000
            });
          }
        } else if (response.status === 'success' && (!response.results || response.results.length === 0)) {
          toast.add({
            severity: 'info',
            summary: 'Nessun File da Importare',
            detail: 'Non sono stati trovati nuovi file GAS da importare nella cartella di origine.',
            life: 6000
          });
        }

      } catch (error) {
        console.error("Errore durante l'importazione GAS nel database:", error);
        toast.add({
          severity: "error",
          summary: "Errore Importazione DB GAS",
          detail: error.response?.data?.message || error.message || "Si è verificato un errore durante l'importazione nel database.",
          life: 6000,
        });
      } finally {
        loading.value = false;
      }
    };

    const fetchImportedFiles = async () => {
      loadingImportedFiles.value = true;
      try {
        const response = await service.getImportedFilesCountTimoe();
        if (response.status === 'success' && response.data) {
          importedFiles.value = response.data;
        } else {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Impossibile recuperare i file importati',
            life: 5000
          });
        }
      } catch (error) {
        console.error("Errore durante il recupero dei file importati:", error);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: error.response?.data?.message || error.message || 'Errore durante il recupero dei file importati',
          life: 5000
        });
      } finally {
        loadingImportedFiles.value = false;
      }
    };

    const searchTimoeData = async () => {
      searchSubmitted.value = true;
      if (!searchCode.value) {
         toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Inserire un codice POD o PDR da cercare.', life: 3000 });
         return;
      }
      
      loadingSearch.value = true;
      searchResults.value = [];
      searchResultType.value = null;

      try {
        const response = await service.getTimoeDataByCode(searchCode.value);
        if (response.status === 'success') {
          searchResults.value = response.data;
          searchResultType.value = response.type;
          if (response.data.length === 0) {
             toast.add({ severity: 'info', summary: 'Info', detail: `Nessun dato trovato per il codice ${searchCode.value}.`, life: 5000 });
          }
        } 
      } catch (error) {
        console.error("Errore ricerca TIMOE/TIMG:", error);
        let detail = 'Errore durante la ricerca dei dati.';
        if (error.response) {
           if (error.response.status === 404) {
              detail = `Nessun dato trovato per il codice ${searchCode.value}.`;
           } else if (error.response.data && error.response.data.message) {
              detail = error.response.data.message;
           }
        }
        toast.add({
          severity: "error",
          summary: "Errore Ricerca",
          detail: detail,
          life: 5000,
        });
      } finally {
        loadingSearch.value = false;
      }
    };
    
    const searchResultColumns = computed(() => {
      if (searchResultType.value === 'pod') {
        return [
          { field: 'cp_gestore', header: 'CP Gestore' },
          { field: 'cod_pod', header: 'COD POD' },
          { field: 'sosp_mor', header: 'Sosp. Mor.' },
          { field: 'presenza_cmor', header: 'Presenza CMOR' },
          { field: 'mercato_provenienza', header: 'Mercato Prov.' },
          { field: 'date_sosp', header: 'Data Sosp.' },
          { field: 'date_switch', header: 'Data Switch' },
          { field: 'data_salvaguardia', header: 'Data Salvag.' },
          { field: 'data_ultima_rich_sosp', header: 'Ult. Rich. Sosp.' },
          { field: 'data_ultima_sosp', header: 'Ult. Sosp.' },
          { field: 'filename', header: 'File Origine' }
        ];
      } else if (searchResultType.value === 'pdr') {
        return [
          { field: 'cod_servizio', header: 'Cod. Servizio' },
          { field: 'cod_flusso', header: 'Cod. Flusso' },
          { field: 'piva_utente', header: 'PIVA Utente' },
          { field: 'piva_gestore', header: 'PIVA Gestore' },
          { field: 'cp_utente', header: 'CP Utente' },
          { field: 'cp_gestore', header: 'CP Gestore' },
          { field: 'cod_pdr', header: 'COD PDR' },
          { field: 'pdr_chiuso_mor', header: 'PDR Chiuso Mor.' },
          { field: 'date_sosp', header: 'Data Sosp.' },
          { field: 'date_sost', header: 'Data Sost.' },
          { field: 'acc_mis', header: 'Acc. Mis.' },
          { field: 'presenza_cmor', header: 'Presenza CMOR' },
          { field: 'data_att_fdd', header: 'Data Att. FDD' },
          { field: 'data_chiusura_pdr', header: 'Data Chiusura PDR' },
          { field: 'filename', header: 'File Origine' }
        ];
      }
      return []; 
    });

    onMounted(() => {
       fetchTimoePaths(); 
       fetchImportedFiles();
    });

    return {
      email,
      logData,
      validationErrors,
      submitted,
      formatTimestamp,
      timoePaths,
      selectedTimoePath,
      timoeFilesToUpload,
      timoeValidationErrors,
      timoeSubmitted,
      handleTimoeFileUpload,
      uploadTimoeFiles,
      loading,
      importEEDatabase,
      importGasDatabase,
      importedFiles,
      activeTab,
      loadingImportedFiles,
      fetchImportedFiles,
      searchCode,
      searchResults,
      searchResultType,
      loadingSearch,
      searchSubmitted,
      searchTimoeData,
      searchResultColumns
    };
  },
};
</script>


<style scoped>
:root {
  --primary-color: #1f5d38;
  --secondary-color: #164628;
  --accent-color: #63796c;
  --background-color: #f8fafc;
  --text-primary: #1a1a1a;
  --text-secondary: #666666;
  --border-color: #e5e7eb;
  --success-color: #4CAF50;
  --error-color: #dc2626;
  --card-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.file-search {
  background: #1f5d38 !important;
  border-color: #1f5d38;
  color: white;
}
.center-content {
  width: 100%;
  padding: 1rem;
}

.w-full {
  width: 100%;
}
.flex.flex-column.w-full {
  display: flex;
  align-items: center; 
}

.input-wrapper {
  width: 60%; 
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-bottom: 1rem;
  justify-content: center; 
}

.email-input {
  flex: 1;
  padding: 0.75rem;
  border: 1px solid var(--border-color);
  border-radius: 4px;
}

.page-title {
  text-align: center;
  margin: 10px auto 20px auto;
  font-size: 1.25rem;
  color: var(--text-primary);
  font-weight: 600;
  padding-bottom: 10px;
  border-bottom: 2px solid var(--border-color);
}

.table-container {
  width: 100%;
  overflow-x: auto;
}

.log-table {
  width: 100%;
  border-collapse: collapse;
}

.log-table th {
  background: var(--primary-color);
  color: white;
  padding: 1rem;
  text-align: left;
  font-weight: 500;
}

.log-table td {
  padding: 1rem;
  border-bottom: 1px solid var(--border-color);
}
.p-error {
  color: var(--error-color);
  margin-top: 0.5rem;
  text-align: center;
  width: 70%;
  margin-left: auto;
  margin-right: auto;
}

.upload-button {
  margin-top: 1rem;
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
  padding: 0.75rem 1.5rem;
}
.upload-button:hover {
  background-color: var(--secondary-color) !important;
  border-color: var(--secondary-color) !important;
}

.button-wrapper {
  position: relative;
  width: 250px;
  text-align: center;
  margin-top: 1rem;
}

.button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #1f5d38;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  border-radius: 3px;
  box-shadow: 0px 10px 13px -7px #00000050, 5px 5px 15px 5px rgba(0, 0, 0, 0);
}

#uploadTimoe {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
  font-size: 0;
}

.custom-dropdown {
  padding: 10px;
  width: 250px;
  border: 1px solid var(--border-color);
  border-radius: 3px;
  background-color: #fff;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23000' stroke-width='2' d='M4 6l4 4 4-4'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px;
  margin-bottom: 1rem;
}

.custom-dropdown:hover {
  border-color: var(--primary-color);
}

@media (max-width: 768px) {
  .input-wrapper {
    flex-direction: column;
  }
  
  .email-input {
    width: 100%;
  }
}

.dropdown-wrapper {
  margin-bottom: 1rem;
  text-align: center;
  display: flex;
  align-items: center; 
  justify-content: center; 
  gap: 0.5rem; 
}

.dropdown-wrapper label {
  font-weight: 500;
}

.p-progress-spinner {
  width: 50px;
  height: 50px;
}

.button-group {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.import-db-button {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.import-db-button:hover {
  background-color: #0b5ed7 !important;
  border-color: #0a58ca !important;
}

.import-gas-button {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.import-gas-button:hover {
  background-color: #0b5ed7 !important;
  border-color: #0a58ca !important;
}

.tabs {
  width: 100%;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  overflow: hidden;
}

.tab-header {
  display: flex;
  border-bottom: 1px solid var(--border-color);
  background-color: #f5f5f5;
}

.tab-button {
  padding: 12px 24px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s;
}

.tab-button:hover {
  background-color: #e9e9e9;
}

.tab-button.active {
  background-color: #ffffff;
  border-bottom: 2px solid var(--primary-color);
}

.tab-content {
  padding: 1rem;
  background-color: #ffffff;
  min-height: 300px;
}

.mt-3 {
  margin-top: 1.5rem;
}

.p-datatable-sm .p-datatable-thead > tr > th {
  padding: 0.5rem 1rem;
  background-color: #f5f5f5;
}

.p-datatable-sm .p-datatable-tbody > tr > td {
  padding: 0.5rem 1rem;
}

.search-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.search-input {
  padding: 0.75rem;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  min-width: 250px; 
}

.search-button {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
  padding: 0.75rem 1.5rem;
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
}
.search-button:hover:not(:disabled) {
   background-color: var(--secondary-color) !important;
   border-color: var(--secondary-color) !important;
}

.search-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
